var _react_refresh_temp_1;
var _react_refresh_temp_2;
_react_refresh_temp_2 = $RefreshSig$();
import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import { APP_UI_KEYS } from './AppUi.constants';
import { AppUiContext } from './AppUiContext';
import { useDiagnosticReportFlow, useExitAppFlow, useLogoutFlow, usePinningFlow, useWorkspaceBar, } from './hooks';
export const AppUiProvider = ({ children }) => {
    _react_refresh_temp_2();
    const { isWorkspaceBarExpanded, setIsWorkspaceBarExpanded } = useWorkspaceBar();
    const { isLogoutFlowInProgress, setIsLogoutFlowInProgress } = useLogoutFlow();
    const { isExitAppFlowInProgress, setIsExitAppFlowInProgress } = useExitAppFlow();
    const { pinRequest, setPinRequest } = usePinningFlow();
    const { isDiagnosticReportFlowInProgress, setIsDiagnosticReportFlowInProgress, } = useDiagnosticReportFlow();
    const value = useMemo(() => ({
        [APP_UI_KEYS.workspaceBar]: {
            isWorkspaceBarExpanded,
            setIsWorkspaceBarExpanded,
        },
        [APP_UI_KEYS.logoutFlow]: {
            isLogoutFlowInProgress,
            setIsLogoutFlowInProgress,
        },
        [APP_UI_KEYS.exitAppFlow]: {
            isExitAppFlowInProgress,
            setIsExitAppFlowInProgress,
        },
        [APP_UI_KEYS.pinningFlow]: {
            pinRequest,
            setPinRequest,
        },
        [APP_UI_KEYS.diagnosticReportFlow]: {
            isDiagnosticReportFlowInProgress,
            setIsDiagnosticReportFlowInProgress,
        },
    }), [
        isWorkspaceBarExpanded,
        setIsWorkspaceBarExpanded,
        isLogoutFlowInProgress,
        setIsLogoutFlowInProgress,
        isExitAppFlowInProgress,
        setIsExitAppFlowInProgress,
        pinRequest,
        setPinRequest,
        isDiagnosticReportFlowInProgress,
        setIsDiagnosticReportFlowInProgress,
    ]);
    return (_jsx(AppUiContext.Provider, { value: value, children: children }));
};
_react_refresh_temp_1 = AppUiProvider;
$RefreshReg$(_react_refresh_temp_1, "AppUiProvider");
_react_refresh_temp_2(AppUiProvider, "LHYxiEt/yWiz+OvMos1wwgwCe50=", false, () => [useWorkspaceBar, useLogoutFlow, useExitAppFlow, usePinningFlow, useDiagnosticReportFlow]);
